import '@babel/polyfill'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { MediaQueries } from 'vue-media-queries'
import store from './store'
import VueIdomooPlayer from '@Shared/plugins/VueIdomooPlayer'
import VueFacebook from '@Shared/plugins/VueFacebook'
import V2Contentful from '@Shared/plugins/V2Contentful'
import Mask from 'di-vue-mask'

import App from './App'

Vue.use(VueFacebook, {
  appId: window.pageData.facebookAppId,
  xfbml: true,
  version: 'v3.0'
})

Vue.use(VueIdomooPlayer, {
  environment: 'https://idoplayer.idomoo.com/17/'
})

Vue.use(VueAxios, axios)

const mediaQueries = new MediaQueries()
Vue.use(mediaQueries)

Vue.use(V2Contentful)

Vue.use(Mask)

/* eslint-disable no-new */
new Vue({
  el: '#checkout-download-app',
  store,
  mediaQueries,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./WebResources/vue/grad-images/checkout-download/main.js